import Vue from 'vue'
export const userInfoBus = new Vue()